export const mockViewerData = {
  // CT studies
  'ORD001': {
    data: {
      template_name: "CT Chest",
      dicom_study_id: "2.25.3118583794435682678620534414467990721",
      clinical_notes: "Patient presents with fever and cough for 3 days",
      clinical_doc_array: [],
      html_report: null,
      raw_report: "Clinical Information: Fever and cough for 3 days\n\nProcedure: CT scan of chest was performed according to standard department protocol.\n\nContrast: None\n\nComparison: None\n\nFindings:\nLungs: Right lower zone consolidation\nPleura: No effusion\nHeart: Normal size\nMediastinum: Normal\n\nOther Relevant Findings: -\n\nIMPRESSION: Right lower zone consolidation, likely infective etiology"
    }
  },
  // MRI studies
  'ORD002': {
    data: {
      template_name: "MRI Brain",
      dicom_study_id: "2.25.276289644059578708952471162097392716359",
      clinical_notes: "Patient with headache and vomiting",
      clinical_doc_array: [],
      html_report: null,
      raw_report: "Clinical Information: Headache and vomiting\n\nProcedure: MRI of brain was performed according to standard department protocol.\n\nContrast: None\n\nComparison: None\n\nFindings:\nBrain Parenchyma: Normal\nVentricles: Normal size and configuration\nSulci: Normal\nMidline: No shift\n\nOther Relevant Findings: -\n\nIMPRESSION: Normal MRI scan of brain"
    }
  },
  
  // X-ray studies
  'ORD003': {
    data: {
      template_name: "XR Chest PA+Decub",
      dicom_study_id: "1.2.840.113619.2.261.4.2147483647.1719323884.764567",
      clinical_notes: "Patient with shortness of breath and chest pain",
      clinical_doc_array: [],
      html_report: null,
      raw_report: "Clinical Information: None\n\nProcedure: PA view of chest.\n\nComparison: No prior imaging is available for comparison.\n\nFindings:\nHardware: None\nBilateral lung fields: Fibrosis seen in left upper and mid zones with volume loss.\nFew reticular opacities in right upper and mid zones.\nMediastinum and Bilateral Hila: Mediastinum is within normal limits.\nTrachea is centrally located.\nCP Angles: No blunting in CP angles is seen.\nCardiac shadow: No significant findings observed in the heart.\nBones: Bony thorax appears unremarkable.\n\nAdditional Findings: Mild left rotation\n\nIMPRESSION:Left upper and mid zone fibrosis with right upper and mid zone subtle reticular opacities - likely caused by old insult.\n\nRadiology Notify System Classification: Acuity\n\nRECOMMENDATION: Clinical correlation and HRCT chest if indicated."
    }
  },

  // X-ray elbow study
  'ORD005': {
    data: {
      template_name: "XR Elbow",
      dicom_study_id: "1.2.840.113564.200.31.102.75.62.208.20201210124934329.1033",
      clinical_notes: "Patient with elbow pain after fall",
      clinical_doc_array: [],
      html_report: null,
      raw_report: "Clinical Information:None \n\nProcedure: X-ray of the elbow was performed according to standard department protocol.\n\nComparison:Nil\n\nFindings:\nBones: Visualized radius and ulna with their ossification centers appear normal.\nFracture Site: Distal end of  humerus.\nAlignment: Displaced\nJoint Spaces: Not preserved\nSoft Tissues: Mild joint effusion\n\nOther relevant findings : None\n\nIMPRESSION: Displaced fracture in distal end of humerus\n\nRECOMMENDATION: None."
    }
  },
  
  // Ultrasound studies
  'ORD004': {
    data: {
      template_name: "USG Abdomen",
      dicom_study_id: "1.3.6.1.4.1.14519.5.2.1.1188.2803.272546201471978974292888446466",
      clinical_notes: "Patient with right upper quadrant pain",
      clinical_doc_array: [],
      html_report: null,
      raw_report: "Clinical Information: Right upper quadrant pain\n\nProcedure: Ultrasound of abdomen was performed according to standard department protocol.\n\nContrast: NA\n\nComparison: None\n\nFindings:\nLiver: Normal size and echotexture\nGallbladder: Multiple calculi\nBile Ducts: Normal caliber\n\nOther Relevant Findings: -\n\nIMPRESSION: Cholelithiasis"
    }
  }
}

